// extracted by mini-css-extract-plugin
export var closeButton = "_8w-0";